import { useEffect, useState } from "react";

/**
 * usePrefersReducedMotion — returns true when the user has
 * requested reduced motion via OS-level accessibility settings.
 * All parallax and cinematic transforms should short-circuit when true.
 */
export default function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReduced(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return reduced;
}
